module.exports = __webpack_public_path__ + "static/black-october-trocar-contador-bg-133fb1b43af4ae6bba9abf61ba4baebf.png";